(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('localizerAutoInit', ['Localizer', 'cookie-utils', 'thd-event-emitter', 'es6-promise'],
      function(Localizer, cookieUtils, thdEventEmitter, es6Promise) {
        return factory(root, Localizer, cookieUtils, thdEventEmitter, es6Promise);
      });
  } else {
    root.localizerAutoInit = factory(root, Localizer, cookieUtils, thdEventEmitter, es6Promise);
  }
})(this, function(root, Localizer, cookieUtils, thdEventEmitter, es6Promise) {
  Localizer.localize();

  return {
    Localizer: Localizer,
    cookieUtils: cookieUtils,
    thdEventEmitter: thdEventEmitter,
    es6Promise: es6Promise
  };
});



//////////////////
// WEBPACK FOOTER
// ./src/localizerAutoInit.js
// module id = 9
// module chunks = 0